import React from "react";
import { Link } from "react-router-dom";
import { trackClick } from "../telemetry";
import Logo from "../assets/composiq-mark-128.png";

const year = new Date().getFullYear();

const footerColumns = [
  {
    title: "Products",
    links: [
      { label: "Zerivo" }
    ]
  },
  {
    title: "Security",
    links: [
      { label: "Trust Center", href: "https://compliance.zerivo.io" },
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
      { label: "Cookies", to: "/cookies" }
    ]
  },
  {
    title: "Company",
    links: [
      { label: "Our Team", to: "/our-team" },
      { label: "Contact", to: "/contact" },
      /* { label: "FAQs", to: "/faqs" } */
    ]
  }
];

const bottomLinks = [
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
  { label: "Contact", to: "/contact" }
];

export default function SiteFooter() {
  return (
    <>
      <div className="site-pre-footer" aria-label="Zerivo">
        <div className="site-pre-footer-inner">
          <Link to="/" className="site-pre-footer-brand" aria-label="Zerivo home">
            <img src={Logo} alt="" className="site-pre-footer-logo" />
            <span className="site-pre-footer-text-group">
              <span className="site-pre-footer-text">Zerivo</span>
              <span className="site-pre-footer-subtitle">Private AI</span>
            </span>
          </Link>
        </div>
      </div>
      <footer className="site-footer" role="contentinfo">
        <div className="site-footer-inner">
          <div className="site-footer-cta">
            <div className="site-footer-cta-text">Private AI your security team can approve.</div>
          </div>

          <div className="site-footer-divider" aria-hidden="true"></div>

          <div className="site-footer-grid">
            {footerColumns.map((column) => (
              <div className="site-footer-column" key={column.title}>
                <div className="site-footer-heading">{column.title}</div>
                <ul className="site-footer-links">
                  {column.links.map((link) => (
                    <li key={link.to || link.href || link.label}>
                      {link.href ? (
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => trackClick(link.label, { placement: "footer" })}
                        >
                          {link.label}
                        </a>
                      ) : link.to ? (
                        <Link 
                          to={link.to}
                          onClick={() => {
                            if (link.label === "Our Team") {
                              trackClick("Our Team", { placement: "footer" });
                            }
                          }}
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <span>{link.label}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="site-footer-bottom">
            <div className="site-footer-copy">© {year} Zerivo</div>
            <div className="site-footer-bottom-links">
              {bottomLinks.map((link) => (
                <Link key={link.to} to={link.to}>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
